__turbopack_context__.v({
  "calculator": "V9oNea_calculator",
  "calculator__axis__label": "V9oNea_calculator__axis__label",
  "calculator__explanation__toggle": "V9oNea_calculator__explanation__toggle",
  "calculator__explanation__toggle_open": "V9oNea_calculator__explanation__toggle_open",
  "calculator__impact": "V9oNea_calculator__impact",
  "calculator__impact__description": "V9oNea_calculator__impact__description",
  "calculator__impact__description__button_desktop": "V9oNea_calculator__impact__description__button_desktop",
  "calculator__impact__description__button_mobile": "V9oNea_calculator__impact__description__button_mobile",
  "calculator__impact__output": "V9oNea_calculator__impact__output",
  "calculator__input": "V9oNea_calculator__input",
  "calculator__input__calculate__label": "V9oNea_calculator__input__calculate__label",
  "calculator__input__calculate__spinner": "V9oNea_calculator__input__calculate__spinner",
  "calculator__input__group": "V9oNea_calculator__input__group",
  "calculator__input__group__input__income__wrapper": "V9oNea_calculator__input__group__input__income__wrapper",
  "calculator__input__group__input__text": "V9oNea_calculator__input__group__input__text",
  "calculator__input__group__percentage_input": "V9oNea_calculator__input__group__percentage_input",
  "calculator__input__group__percentage_input_wrapper": "V9oNea_calculator__input__group__percentage_input_wrapper",
  "calculator__input__group__percentage_text": "V9oNea_calculator__input__group__percentage_text",
  "calculator__input__group_mobile": "V9oNea_calculator__input__group_mobile",
  "calculator__input__inner": "V9oNea_calculator__input__inner",
  "calculator__input_slider": "V9oNea_calculator__input_slider",
  "calculator__output": "V9oNea_calculator__output",
  "calculator__output__chart": "V9oNea_calculator__output__chart",
  "calculator__output__spinner": "V9oNea_calculator__output__spinner",
  "wrapper": "V9oNea_wrapper",
});
